export default {
  /**
   * Nav Section
   */
  'nav.renewal_portal': 'Portail du Renouvellement',
  'nav.select_branches': 'Sélectionnez des branches',

  /**
   * Drawer Section
   */
  'drawer.dashboard': 'Tableau de bord',
  'drawer.renewal_portal': 'Portail du Renouvellement',
  'drawer.completed_renewals_portal_url':
    'Portail des renouvellements complétés',
  'drawer.reports_portal_url': 'Portail des rapports',
  'drawer.imitate_employee': 'Imiter un employé',
  'drawer.admin_panel': 'Panneau d’administration', //Google translated
  'drawer.welcome': 'Bienvenue',
  'drawer.select_branches': 'Sélectionnez des branches',
  'drawer.inactive_branches': 'Branches inactives',
  'drawer.version': 'Version',
  'drawer.branch_overrides': 'Overrides branche',
  'drawer.managed_restroom_services': 'MRS',

  /**
   * Dashboard Panels
   */
  'Past Due': 'En souffrance',
  '0-3 Months': '0-3 mois',
  '3-6 Months': '3-6 mois',
  '6-12 Months': '6-12 mois',
  '12-18 Months': '12-18 mois',
  '18+ Months': '+18 mois',
  'Awaiting Signature': 'En attente de signature',
  renewal_past_due: 'En souffrance',
  renewal_zerotothree_months: '0-3 mois',
  renewal_threetosix_months: '3-6 mois',
  renewal_sixtotwelve_months: '6-12 mois',
  renewal_twelvetoeighteen_months: '12-18 mois',
  renewal_eighteenmonths_plus: '+18 mois',
  customer_name_or_number: 'Nom ou numéro de client',

  /**
   * Dashboard Panels
   */
  'renewals_action_panel.title': 'Approbation requises',

  /**
   * Renewal page
   */
  rental_service_agreement: 'Entente de service de location',
  last: 'Dernier',
  days: 'jours',
  margin_rating: 'Taux de marge',
  bill_to: 'Facturé à',
  deliver_to: 'Livré à',
  district: 'Région',
  customer: 'Client',
  product: 'Product',
  rental_price: 'Prix de location',
  sales_price: 'Prix de vente',
  wash_price: 'Prix de lavage',
  replace_price: 'Prix de remplacement',
  rent_qty: 'Quantité en location',
  del_qty: 'Quantité livrée',
  minimum_use_percentage: '% Usage Min',
  inventory_maintenance: 'Maintenance de linventaire',
  image_care_price: 'Prix Soin Image',
  delivery_frequency: 'Fréquence de livraison',
  number_of_wearers: '# de porteurs',
  number_of_items_per_wearer: "# d'articles/porteur",
  circ_inv: 'Inventaire circulaire',
  weekly_usg: 'Utilisation Hebdomadaire',
  start_renewal: 'Commencer le renouvellement',
  renewals_action_panel_title: 'Les clients',
  close_renewal: 'Fermer',
  renewal: 'Renouvellements',
  next: 'Suivant',
  customer_uses_general_price_list:
    'Le client utilise la liste de prix générale',
  customer_uses_excluded_product: 'Le client utilise des produits exclus',
  customer_uses_excluded_src_types: 'Le client a exclu les types SRC et ne peut pas être renouvelé',
  customer_contract_not_viewable: "Impossible de voir l'entente du client",
  renewal_requires_approval:
    'Un ou plusieurs produits nécessitent une approbation',
  product_details: 'détails du produit',
  approval_required_reason: 'Approbation requise Raison',
  line_item_requires_approval:
    'Ce produit contient des modifications qui nécessitent une approbation',
  renewal_created: 'Renouvellement créé',
  error_updating_renewal: 'Erreur mise à jour renouvellement',
  renewal_updated: 'Renouvellement mis à jour',
  error_creating_renewal: "Erreur lors de la création d'un renouvellement",
  renewal_sent_forward: 'Renouvellement envoyé en avance',
  error_sending_renwal_forward: "Erreur d'envoi d'un renouvellement en avance",
  renewal_closed: 'Renouvellement fermé',
  error_closing_renewal: 'Erreur fermeture de renouvellement ',
  error_validating_renewal: 'Erreur lors de la validation du renouvellement',
  yes_Close_this_renewal: 'Oui, fermer ce renouvellement',
  cancel: 'Annuler',
  save: 'Sauvegarder',
  renewal_term: 'Période de renouvellement',
  rollover_term: 'Période de prolongation',
  options: 'Options',
  close_renewal_paragraph:
    'Êtes-vous sûr de vouloir fermer ce renouvellement sans le compléter ? Une fois fermé, le processus de renouvellement devra recommencer depuis le début.',
  service_charges: 'Frais de service',
  description: 'Description',
  amount: 'Montant',
  delivery_minimum: 'Minimum de livraison',
  service_charge: 'Frais de service',
  yes_priceprotect_customer: 'Oui, Price Protect Customer',
  no_donot_priceprotect_customer: 'Non, ne pas protéger prix client',
  do_not_automatically_renew: 'Ne pas renouveler automatiquement',
  '1_year': '1 an',
  '2_years': '2 ans',
  '3_years': '3 ans',
  '4_years': '4 ans',
  '5_years': '5 ans',
  years: 'ans',
  customer_signature_required: 'Signature du client requise',
  confirm_service_agreement:
    'Le contrat de service nécessite l’approbation du client avant d’être finalisé. Le client recevra un e-mail avec un lien pour examiner et accepter le contrat de service. Le RSR exploitant l’itinéraire client sera également notifié pour obtenir l’approbation du client.', //Translated by Google
  resend_confirm_service_agreement:
    'Cet accord de service est en attente de signature du client. Si un e-mail a déjà été fourni, le client a déjà reçu un e-mail avec un lien vers un avis. Si un e-mail n’a pas encore été fourni, le client devra signer sur l’ordinateur de poche du RSR. Pour renvoyer l’accord, veuillez vérifier et/ou modifier l’adresse e-mail et le nom ci-dessous et cliquez sur ‘Renvoyer au Client‘',
  signature_full_name_placeholder:
    "Veuillez saisir le nom complet de l'approbateur",
  signature_email_address_placeholder:
    "S'il vous plaît, saisissez une adresse email valide",
  approval_contact: "Contact d'approbation",
  contact_first_and_last_name: 'Prénom et nom du contact',
  contact_email: 'Courriel du contact',
  select_contact: 'Sélectionnez Contact',
  send_to_customer: 'Envoyer au client',
  resend_to_customer: 'Renvoyer au client', //Translated by Google
  update_contact: 'Mettre à jour le contact', //Translated by Google
  competitor_pricing: 'Prix de la compétition',
  reason_for_adjustment: 'Raison pour ajustement',
  reason_for_approval: 'Approbation requise',
  approval_required: 'Approbation exigée',
  no_reasons_provided: 'Aucune raison fournie',
  Dialog_para:
    "L'entente de service comporte des ajustements qui nécessitent l'approbation de la direction. Soumettre l'entente pour examen. Une fois approuvé, l'accord indiquera qu'il est prêt à saisir une signature lors d'une livraison future.",
  submit_for_approval: 'Soumettre pour approbation',
  green_rate: 'Taux vert',
  red_rate: 'Taux rouge',
  mad_rate: 'Tarif MAD',
  current_contract_rate: "Taux actuels de l'entente",
  current_contract_rate_and_mad: "Taux actuels de l'entente\\Taux MAD",
  new: 'Nouveau',
  below_red_rate_message: "L'ajustement de prix est inférieur au taux rouge.",
  different_tier_message:
    "L'ajustement de prix appartient à un niveau différent.",
  no_rates_provided_message: 'Aucun taux rouge / vert disponible.',
  price_approval_message: "L'ajustement des prix nécessite une approbation.",
  new_rate: 'Nouveau taux',
  current_rate: 'Taux actuel',
  action_not_allowed: 'Modification non autorisée.', // GOOGLE TRANSLATE
  approval_note_1: 'Ce sera une',
  approval_note_2:
    "L'entente de service comporte des ajustements qui nécessitent l'approbation de la direction. L'approbation est requise pour les raisons suivantes",
  increase: 'augmenter',
  discount: 'réduction',
  approval_reason_message:
    "Le contrat de service comporte des ajustements qui nécessitent l'approbation de la direction. L'approbation est requise pour les raisons suivantes",
  tier1_approval: 'Ajustements de niveau 1 - Approbation DV',
  tier2_approval: 'Ajustements de niveau 2 - Approbation du DG',
  generic_validation_error: "Une erreur de validation inconnue s'est produite",
  quantity_decreased: 'La quantité a été réduite',
  service_charge_decreased: 'Frais de service réduits',
  price_protection_not_qualified: 'Protection des prix non qualifiée',
  reason_given: "Raison donnée': ",
  restroom_services: 'Services de salles de bain',
  quantity_less_than_one: 'La quantité ne peut pas être inférieure à 1',
  customer_eligibility: 'Éligible au renouvellement le',
  start_editing: "Commencer l'édition",
  save_changes: 'Sauvegarder les modifications',
  revert_changes: 'annuler',
  renewal_term_approval_needed:
    "L'ajustement de la durée du renouvellement nécessite une approbation",
  code: 'Code',
  size: 'Taille',
  renewal_not_available:
    "Le renouvellement auquel vous tentez d'accéder n'est plus disponible. Veuillez contacter votre équipe de service pour toute question.",
  error_getting_renewal:
    "Une erreur inattendue est apparue. Si cela se reproduit, veuillez contacter votre équipe de service pour obtenir de l'aide.",
  generate_proposal: 'Proposition',

  /**
   * Days of the week
   */
  all_routes: 'Toutes les routes',
  all_districts: 'Tous les quartiers',
  all_days: 'Tous les jours',
  monday: 'Lundi',
  tuesday: 'Mardi',
  wednesday: 'Mercredi',
  thursday: 'Jeudi',
  friday: 'Vendredi',
  saturday: 'Samedi',
  sunday: 'Dimanche',

  /**
   * Customer Renewal Columns
   */
  customer_number: 'Client #',
  customer_name: 'Nom du Client',
  awr: 'RHM',
  awrv: 'RHM',
  price_increase: 'Augmentation de prix',
  exp_date: "Date d'expiration(MM/DD/YYYY)",
  route: 'Route',
  renewal_status: 'Statut de renouvellement',
  renewals: 'Renouvellements',
  'requiring_approval.title': 'Approbation requise',
  'exceptions_awaiting_customer_signature.title':
    'Exceptions en attente de la signature du client',
  'awaiting_customer_signature.title': 'En attente de la signature du client',
  see_all: 'Voir tout',
  customer_forms: 'Formulaires des clients',
  'customer_table_approval_required.title': 'Approbation%20requise',
  'customer_table_awaiting_customer_signature.title':
    'En%20attente%20de%20la%20signature%20du%20client',
  'customer_table_past_due.title': 'En%20souffrance',
  proposed_date: 'Date proposée',
  resend_signature_email: "Retourner l'e-mail de signature du client",
  base_price_increase: 'Augmentation du prix de base', // GOOGLE TRANSLATE
  /*
              Sign out button
            */
  sign_out: 'Déconnexion',

  /*
             Login Page
            */
  username: "Nom d'utilisateur",
  password: 'mot de passe',
  login: 'Connexion',
  version: 'Version',

  /*
   * Completed renewal
   */

  renewed_below_MAD_or_qty_decreased: 'Renouvelé sous MAD ou quantité diminuée',
  renewal_within_MAD: 'Renouvellement dans MAD',
  renewal_with_no_deviation: 'Renouvellement sans dérogation',
  within_mad_classification: 'Dans MAD',
  below_mad_classification: 'En dessous de MAD / Quantité Diminuée',
  no_deviation_classification: 'Aucune déviation',
  no_classification: 'Pas de classement',
  completed_last_7_days: '7 derniers jours complétés',
  completed_last_30_days: '30 derniers jours complétés',
  completed_last_90_days: '90 derniers jours complétés',
  completed_all_time: 'Complété tous le temps',
  all_time: 'Tout le temps',
  completed_renewals: 'Renouvellements complétés',
  enter_customer_name_or_number: 'Entrez le nom ou le numéro du client',
  margin_score: 'Indice de marge',
  completed: 'Complété(e)',
  route_CSR: '# route/RSR',
  bucket: 'Récipient',
  completed_renewal_actions: 'Actions',
  contract: 'Entente',
  completed_renewals_portal: 'Portail des renouvellements complétés',
  reports_portal: 'Portail des rapports',
  pdf_error_message:
    'Erreur: PDF non disponible, svp contacter votre administrateur.',
  email_success_message: 'E-mail envoyé avec succès.',
  email_error_message:
    "Erreur: l'e-mail n'a pas pu être envoyé, veuillez contacter votre administrateur.",

  /*
   * Completed Renewal Report
   */
  route_number: 'Numéro de route',
  employee_name: "Nom de l'employé",
  average_weekly_revenue: 'Revenu hebdomadaire moyen',
  branch_margin_rating: 'Taux de marge de la succursale',
  classification: 'Classification',
  completed_date: 'Date de fin (MM/JJ/AAAA)',
  selected_date_range_invalid_message:
    "La plage de dates sélectionnée n'est pas valide, veuillez réessayer.",
  completed_renewals_report_success_message: 'CSV téléchargé avec succès.',
  no_deviation_renewals_report_success_message:
    'Rapport téléchargé avec succès',
  completed_zip_report_success_message:
    'Les rapports sur les contrats de renouvellement terminés ont été téléchargés avec succès',
  no_completed_renewals_in_this_time_period_message:
    "Il n'y a aucun renouvellement terminé dans la plage de dates sélectionnées. Le CSV n'a pas été téléchargé.",
  no_deviation_renewals_not_available_in_this_time_period_message:
    "Il n'y a aucun renouvellement sans écart dans la plage de dates sélectionnée. CSV n'a pas été téléchargé.",
  no_completed_renewal_contracts_in_this_time_period_message:
    "Il n'y a pas de contrats de renouvellement terminés dans la plage de dates sélectionnée. Le fichier ZIP n'a pas été téléchargé.",
  completed_renewals_report_failed_to_generate_csv_message:
    "Une erreur s'est produite lors de la génération de votre rapport, veuillez réessayer ou contacter votre administrateur.",
  no_deviation_renewals_report_failed_to_generate_csv_message:
    "Une erreur s'est produite lors de la génération de votre rapport de renouvellement sans écart, veuillez réessayer ou contacter votre administrateur",
  completed_renewal_contracts_failed_to_generate_csv_message:
    "Une erreur s'est produite lors de la génération de vos contrats de renouvellement terminés, veuillez réessayer ou contacter votre administrateur",
  completed_renewals_report_error_message:
    "Une erreur s'est produite dans la réception de votre rapport. Veuillez réessayer ou contacter votre administrateur",
  no_market_center_report_found: 'Aucun rapport de succursale trouvé',
  no_awaiting_approval_found: "Aucun rapport d'approbation en attente trouvé",
  market_center_report_failed_respond:
    'Le rapport de la succursale ne répond pas',
  market_center_report_error_message:
    "Une erreur s'est produite lors de l'obtention de rapport de votre succursale",
  awaiting_approval_report_error_message:
    "Une erreur s'est produite lors de la récupération de votre rapport d'approbation en attente",
  export_mc_report: "Rapport d'exportation de succursale",
  start_date: 'Date de début',
  end_date: 'Date de fin',
  export_completed_report:
    'Exporter le rapport sur les renouvellements terminés',
  export_completed_renewal_contracts:
    'Exporter les contrats de renouvellement terminés',
  export_no_deviation_renewal_reports:
    'Exporter les rapports de renouvellement sans écart',
  previous_CXD: "Date d'expiration du contrat précédent",
  new_CXD: "Date d'expiration du nouveau contrat",
  renewal_id: 'Identifiant de renouvellement',
  employee_id: "Identifiant de l'employé",
  employee_role: "Rôle de l'employé",
  district_code: 'Code de district',
  completed_renewals_report: 'Rapport de renouvellements complétés',
  awaiting_approvals_report: "Rapport d'approbations en attente",
  market_center_report: 'Rapport de succursale',
  total_initiated: 'Total initié',
  dm_initiated: 'TM lancé',
  rsr_initiated: 'RSR lancé',
  rsr_name: 'RSR Nom',
  other_initiated: 'Autre Initié',
  market_center: 'Succursale',
  proposed: 'Proposé',
  within_mad: 'Dans MAD',
  total_proposed: 'Total proposé',
  total_completed: 'Total terminé',
  total_within_mad: 'Total dans MAD',
  total_csr_proposed: 'Total RSR proposé',
  total_csr_completed: 'Total RSR terminé',
  total_csr_within_mad: 'Total RSR dans MAD',
  total_dm_proposed: 'Total TM proposé',
  total_dm_completed: 'Total TM terminé',
  total_dm_within_mad: 'Total TM dans MAD',
  total_other_proposed: 'Total Autres proposé',
  total_other_completed: 'Total Autres terminé',
  total_other_within_mad: 'Total Autres dans MAD',
  clear_reset: 'Effacer / Réinitialiser',
  proposed_by: 'Proposé par',
  /*
   * Actions
   */
  'action.clear': 'Effacer',
  'action.approve': 'Approuver',
  'action.add': 'Ajouter',
  'action.remove': 'Supprimer',
  'action.submit': 'Soumettre',

  /*
   * Admin Branch Pages
   */
  available_branches: 'Branches Disponibles',
  inactive_branches: 'Branches Inactives',
  selected_branches: 'Branches Sélectionnées',
  branch_code: 'Code de la Branche',
  branch_description: 'Description de la Branche',
  manage_branch_override: 'Gérer les overides de branches',

  /*
   * Terms And Conditions Page
   */
  twelve: 'Douze',
  twenty_four: 'vingt-quatre',
  thirty_six: 'trente-six',
  fourty_eight: 'quarante-huit',
  sixty: 'soixante',

  /*
   * Customer Signature Page
   */
  terms_and_conditions: 'Termes et Conditions',
  service_promise_paragraph_part_1: 'Cette entente est sujette aux',
  service_promise_paragraph_part_2:
    "J'accepte, au nom du client, les termes et conditions du ou des ententes de service et je suis autorisé à le faire.",
  signature_promise:
    "Je comprends et accepte que ma signature fournie ci-dessus sera appliquée au(x) entente(s) de service et qu'une copie du ou des ententes de service sera envoyée à l'adresse e-mail fournie.",
  terms_acknowledgement:
    "J'accepte, au nom du client, les termes et conditions du ou des ententes de service et je suis autorisé à le faire.",
  approver_full_name: 'Nom complet de l’approbateur.',
  approver_email: 'Courriel de l’approbateur',
  approver_signature: 'Signature d’approbation',
  thank_you:
    "Merci d'avoir renouvelé votre contrat. Vous pouvez fermer cette fenêtre maintenant.",
  start_signing: "Examiner les conditions générales et signer l'entente",
  clear: 'Effacer',
  redirect:
    "La signature a déjà été soumise. Redirection vers la page d'accueil de Canadian Linen.",
  redirect_to: 'https://www.canadianlinen.com/',
  /*
   * Customer Forms Portal Page
   */
  customer_lead: 'Référence de clients',
  tig_lead: 'Référence Lead',
  direct_sales_lead_us: 'Référence Vente Directe Aramark US',
  direct_sales_form_ca: 'Formulaire de référence Vente Directe - CA',
  internal_network_disclaimer:
    'Seulement disponible sur le réseau interne d’Aramark',

  /*
   * Error messages
   */
  error_001:
    'Connection impossible. Veuillez contacter votre administrateur et lui faire vérifier votre configuration ABS et celle de votre branche',
  error_002: "Nom d'utilisateur ou mot de passe invalide.",
  error_003: 'Un problème inconnu est survenu.',
  error_004:
    "L'utilisateur est verrouillé en raison d'un trop grand nombre de tentatives de connexion ",
  error_005:
    "Aucun rôle valide trouvé pour le titre de l'utilisateur. Veuillez contacter votre administrateur et lui demander de mettre à jour les mappages de tâches.",
  error_006:
    'Mode administrateur uniquement. Les non-administrateurs ne peuvent pas se connecter actuellement',
  /*
   * Emblem Charges
   */
  emblem_charges: "Frais d'emblème",
  company_charge: 'Frais Compagnie',
  name_charge: 'Frais nom',
  other_charge: 'Autre Frais Spéciaux',
  /*
   * Users
   */
  'user.CSR': 'RSR',
  'user.CSM': 'Directeur de territoire',
  'user.COM': 'Directeur du service ',
  'user.CAM': 'CAM',
  'user.C3': 'C3',
  'user.ADMIN': 'Admin',
  'user.VPO': 'VPO',
  'user.GM': 'Directeur général',
  'user.RVP': 'RVP',
  'user.RMT': 'RMT',

  /*
   * Admin Panel
   */
  config_name: 'Nom:', // GOOGLE TRANSLATE
  config_description: 'Description:', // GOOGLE TRANSLATE
  config_value: 'Valeur:', // GOOGLE TRANSLATE

  /**
   * MRS
   */
  back: 'Retourner', // GOOGLE TRANSLATE
  review: 'Revoir', // GOOGLE TRANSLATE
  edit: 'Modifier', // GOOGLE TRANSLATE
  mrs_continue: 'Continuer', // GOOGLE TRANSLATE
  mrs_validation_general_error:
    'Veuillez résoudre les erreurs ci-dessus avant de continuer.', // GOOGLE TRANSLATE
  mrs_dispenser_required_error: 'Un distributeur est requis pour cet article.', // GOOGLE TRANSLATE
  mrs_dispenser_no_fill_item_error:
    'Un seul distributeur peut être sélectionné.', // GOOGLE TRANSLATE
  mrs_dispenser_too_many_error:
    'Impossible de commander un distributeur sans article à remplir.', // GOOGLE TRANSLATE
  mrs_order_in_progress_warning:
    'Il y a déjà une commande en cours pour ce client. Allez-vous continuer à travailler dessus ?', // GOOGLE TRANSLATE
  mrs_order_already_completed_warning:
    'Ce client a déjà une commande MRS complétée. Les modifications ne sont actuellement pas prises en charge.', // GOOGLE TRANSLATE
  mrs_search_customers_hint: 'Rechercher des clients', // GOOGLE TRANSLATE
  mrs_search_button_text: 'Recherche', // GOOGLE TRANSLATE
  mrs_thank_you: 'Merci. Votre commande a été soumise.' // GOOGLE TRANSLATE
};
